import { cn, useIsGummy } from "@swivu/shared-ui";
import { useTeamSchedule } from "./TeamScheduleContext.js";
import DateRangeSelector from "./DateRangeSelector.js";
import TeamScheduleDay from "./TeamScheduleDay.js";
// import TeamScheduleDropdown from "../../../../components/TeamScheduleDropdown";

const TeamScheduleFilter = () => {
  const { dateRange } = useTeamSchedule();
  const isGummy = useIsGummy();

  return (
    <div
      className={cn(
        "dark:text-mono-200 @3xl:top-[0px] sticky top-[95px] z-10",
        isGummy
          ? "bg-mono-200 dark:bg-mono-950"
          : "bg-mono-200 dark:bg-mono-950"
      )}
    >
      <div>
        <DateRangeSelector />
      </div>
      <div
        className={cn(
          "@3xl:top-[160px] @3xl:grid-cols-5 z-10 grid w-full grid-cols-5 px-2",
          isGummy ? "py-3" : "py-2 sm:pt-2",
          isGummy
            ? "bg-mono-200 dark:bg-mono-950"
            : "bg-mono-200 dark:bg-mono-950 border-border border-b"
        )}
      >
        <div
          className={`align-center hidden h-full  flex-col items-center justify-evenly `}
        >
          <span>Name</span>
        </div>

        {dateRange.map((day, _index) => {
          return (
            <div
              key={day.toISOString()}
              className={cn(
                "flex items-center justify-center",
                isGummy ? "py-3" : "py-2"
              )}
            >
              <TeamScheduleDay day={day} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TeamScheduleFilter;
